module.exports = __webpack_public_path__ + "static/background-7132b52a2292bd427dbc92a64a8b4cc7.jpg";